function isObjectLike(value: any) {
    return typeof value === 'object' && value !== null
}

function getTag(value: any) {
    if (value == null) {
        return value === undefined ? '[object Undefined]' : '[object Null]'
    }
    return Object.prototype.toString.call(value)
}

// 这个 isPlainObject 函数用于判断一个值是否为“纯粹的对象”（plain object），即由 {} 或 new Object() 创建的对象，而不是数组、函数、Date、RegExp、null、实例对象等。
function isPlainObject(value: any) {
    if (!isObjectLike(value) || getTag(value) != '[object Object]') {
        return false
    }
    if (Object.getPrototypeOf(value) === null) {
        return true
    }
    let proto = value
    while (Object.getPrototypeOf(proto) !== null) {
        proto = Object.getPrototypeOf(proto)
    }
    return Object.getPrototypeOf(value) === proto
}

export default isPlainObject
